export default "__VITE_ASSET__Cz6F7LJA__"